/* eslint-disable-next-line */
export interface NavSpacerProps {}

export function NavSpacer(props: NavSpacerProps) {
  return (
    <li className="h-[64px]">
      <div className="text-lg font-semibold" />
    </li>
  );
}

export default NavSpacer;
